<template>
  <div>
    <div v-for="studio in Object.keys(studios)" :key="studio" class="container">
      <div class="studio__title">
        <p>{{text[studio]}}</p>
      </div>
      <vue-glide
        class="demo"
        ref="slider"
        v-model="active"
        type="carousel"
        :perView="2"
        focusAt="center"
        :key="studio"
      >
        <vue-glide-slide v-for="photo in studios[studio]" :key="photo">
          <div class="photoStudios">
            <img class="imageReno" :src="getImage(photo, studio)"/>
          </div>
        </vue-glide-slide>
        <template slot="control">
          <button
            class="slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev"
            data-glide-dir="<"
          >
            &lt;
          </button>
          <button
            class="slider__arrow slider__arrow--next glide__arrow glide__arrow--next"
            data-glide-dir=">"
          >
            &gt;
          </button>
        </template>
      </vue-glide>
    </div>
  </div>
</template>

<script>
import jsonData from "../data/dataSpecificRenovation.json";
const text = {
  "salle-de-bain": "Salle de bain",
  chambre: "Chambre",
  cuisine: "Cuisine",
  decorations: "Décorations",
  salon: "Salon",
  escaliers: "Escaliers",
};
export default {
  name: "Renovations",
  data() {
    return {
      studios: jsonData,
      text,
    };
  },

  methods: {
    getImage: function(photo, studio) {
      return require(`../assets/${studio}/${photo}`);
    },
  },
};
</script>
<style>
.studio__title {
  font-size: 50px;
}
.photoStudios,
.imageReno {
  width: 100%;
}
.photoStudios {
  height: 100%;
  display: flex;
  align-items: center;
}

@media only screen and (min-width: 375px) and (max-width: 812px) {
  .innerSpan {
    width: 100px;
  }
}
.blueimp-gallery > .prev,
.blueimp-gallery > .next {
  line-height: 30px;
}
.blueimp-gallery > .next {
  padding-left: 4px;
}
.blueimp-gallery > .prev {
  padding-right: 4px;
}
.glide__arrow {
  position: absolute;
  display: block;
  top: 50%;
  z-index: 2;
  color: white;
  text-transform: uppercase;
  padding: 9px 12px;
  background-color: transparent;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.1);
  text-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.1);
  opacity: 1;
  cursor: pointer;
  transition: opacity 150ms ease, border 300ms ease-in-out;
  transform: translateY(-50%);
  line-height: 1;
}
.glide__arrow:focus {
  outline: none;
}
.glide__arrow:hover {
  border-color: white;
}
.glide__arrow--left {
  left: 2em;
}
.glide__arrow--right {
  right: 2em;
}
.glide__arrow--disabled {
  opacity: 0.33;
}
.glide__bullets {
  position: absolute;
  z-index: 2;
  bottom: 2em;
  left: 50%;
  display: inline-flex;
  list-style: none;
  transform: translateX(-50%);
}
.glide__bullet {
  background-color: rgba(255, 255, 255, 0.5);
  width: 9px;
  height: 9px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  line-height: 0;
  box-shadow: 0 0.25em 0.5em 0 rgba(0, 0, 0, 0.1);
  margin: 0 0.25em;
}
.glide__bullet:focus {
  outline: none;
}
.glide__bullet:hover,
.glide__bullet:focus {
  border: 2px solid white;
  background-color: rgba(255, 255, 255, 0.5);
}

.glide__bullet--active {
  background-color: white;
}
.glide--swipeable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.glide--dragging {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.slider__arrow--next {
  right: 0;
}
.glide__slide {
  height: auto !important;
}
</style>
